import React, { memo } from 'react'
import { Trans } from 'react-i18next'

import {
  TERMS_COND_URL,
  PRIVACY_POLICY_URL
} from '../../constants/externalResources'
import { SIGN_UP_PROFILE_DISPATCH } from '../../store/reducers/auth/signup'
import Link from '../shared/link/Link'
import Text from '../shared/text/Text'
import Checkbox from '../shared/inputs/Checkbox'
import { transWithArgs } from '../../util/validation.helpers'

const AcceptTerms = ({
  t,
  signupProfile: { termsAccepted, error },
  dispatchAction
}) => {
  return (
    <>
      <Text label={t('sign-up.accept-terms-desc')} />
      <Checkbox
        label={
          <Trans i18nKey='sign-up.accept-terms'>
            <Link
              isOutside
              to={TERMS_COND_URL}
              label={t('common.terms-conditions')}
            />
            <Link
              isOutside
              to={PRIVACY_POLICY_URL}
              label={t('common.privacy-policy')}
            />
          </Trans>
        }
        errorMessage={transWithArgs(
          t,
          error[SIGN_UP_PROFILE_DISPATCH.TERMS_ACCEPTED]
        )}
        checked={termsAccepted}
        onChange={() =>
          dispatchAction(
            SIGN_UP_PROFILE_DISPATCH.TERMS_ACCEPTED,
            !termsAccepted
          )
        }
      />
    </>
  )
}

export default memo(AcceptTerms)
